<template>
  <div>
    <div class="page-header-wrapper" v-if="showHeader">
      <div class="page-header">
        <h1><slot name="page-title"></slot></h1>
        <slot name="header-slot"></slot>
      </div>
      <p class="subtitle"><slot name="page-subtitle"></slot></p>
    </div>
    <slot name="default"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const name = 'page'

const props = {
  showHeader: {
    type: Boolean,
    required: false,
    default: true
  }
}

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile'
  })
}

export default {
  name,
  props,
  computed
}
</script>

<style>
.page-header-wrapper {
  padding: 10px 0;
  margin: 0 auto;
}

.page-header {
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 5px;
}
</style>
